import httpService from "@src/utility/httpService";
import { config } from '@uhg-abyss/web/tools/config';
import { SettlementConstants } from './constants';
import { checkGeoFlow, checkHCO, checkMultiTin, checkSingleTin } from "@src/utility/createStorage";
const _httpService = new httpService();

_httpService.setBaseURL(config('API_DOMAIN_INTERNAL'));

export const getSettlementOVerviewData = async (payload?: any) => {
    const url = '/settlements/settlements-overview-details/';
    try {
        let response: any;
        response = await _httpService.push(url, payload);
        return response;
    }

    catch {
        return null;
    }
};

export const getSettlementPaymentData = async (payload?: any) => {
    const url = '/settlements/settlements-payment/';
    try {
        let response: any;
        response = await _httpService.push(url, payload);
        return response;
    }

    catch {
        return null;
    }

};
export const getSettlementVolumeData = async (payload?: any) => {
    const url = '/settlements/volume-details/';
    // if(getSettlementCurrentFlow() === 'SINGLE_TIN' || getSettlementCurrentFlow() === "MULTI_TIN"){
    //      payload.StartDate = undefined;
    //      payload.EndDate = undefined;         
    // }
    try {
        let response: any;
        response = await _httpService.push(url, payload);
        return response;
    }

    catch {
        return null;
    }

};
export const getSettlementCurrentFlow = () => {
    if (checkSingleTin()) return 'SINGLE_TIN';
    if (checkMultiTin()) return 'MULTI_TIN';
    if (checkGeoFlow()) return 'GEO_FLOW';
    if (checkHCO()) return 'HCO';
    return undefined; // Default return if none of the conditions are met
}
export const getDateRange = (value: string): string | null => {
    const today = new Date();
    let startDate: Date;

    if (/^\d{4}$/.test(value)) { // Check if value is a year (e.g., "2024", "2023")
        const year = parseInt(value, 10);
        startDate = new Date(year, 0, 1); // Start of the year
        const endDate = new Date(year, 11, 31); // End of the year
        const formatDate = (date: Date) => {
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const year = date.getFullYear();
            return `${year}-${month}-${day}`;
        };
        return `${formatDate(startDate)} - ${formatDate(endDate)}`;
    }

    switch (value) {
        case "Last12Months":
            startDate = new Date(today.getFullYear() - 1, today.getMonth(), today.getDate() + 1);
            break;
        case "Last6Months":
            startDate = new Date(today.getFullYear(), today.getMonth() - 6, today.getDate() + 1);
            break;
        case "Last3Months":
            startDate = new Date(today.getFullYear(), today.getMonth() - 3, today.getDate() + 1);
            break;
        default:
            return null;
    }

    const formatDate = (date: Date) => {
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const year = date.getFullYear();
        return `${year}-${month}-${day}`;
    };

    return `${formatDate(startDate)} - ${formatDate(today)}`;
};
export const getSettlementPaymentPayload = (payload: any, currentFlow: string | undefined) => {
    let settlementPayload: any = {};
    switch (currentFlow) {
        case 'SINGLE_TIN': {
            settlementPayload = {
                StartDate: payload.ProviderSysKey,
                EndDate: payload.Tin,
                Tin: payload.TimeFilter
            };
            break;
        }
        case 'MULTI_TIN': {
            settlementPayload = {
                StartDate: payload.ProviderSysKey,
                EndDate: payload.Tin,
                Tin: payload.TimeFilter
            };
            break;
        }
        case 'GEO_FLOW': {
            settlementPayload = {
                TimeFilter: "Last12Months",
                Region: "Central",
                State: "Virginia,Texas",
                Market: ["LI & Westchester, NY - 31530", "Fairfax, VA - 45595", "Dallas, TX - 42577"]
            }
            break;
        }
        case 'HCO': {
            settlementPayload = {
                StartDate: payload.ProviderSysKey,
                EndDate: payload.Tin,
                Tin: payload.TimeFilter
            };
            break;
        }
        default:
    }
    return settlementPayload;
};
export const getSettlementTrendData = async (payload?: any) => {
    const url = '/settlements/settlements-trend';
    try {
        let response: any;
        response = await _httpService.push(url, payload);
        return response;
    }

    catch {
        return null;
    }

};

export const getSettlementDetailsFetchData = async (payload?: any, type?: string) => {
    const url = '/settlements/settlements-details';
    const modifiedPayload = { ...payload, Type: type };
    try {
        let response: any;
        response = await _httpService.push(url, modifiedPayload);
        return response;
    }

    catch {
        return null;
    }

}

export const geoValFetch = (geoValues: any, geoType: string) => {
    if (geoValues.length === 0 && (geoType === 'region' || geoType === 'state')) return '';
    if (geoValues.length === 0 && geoType === 'market') {
        return [];
    } else if (geoValues.length > 0) {
        geoValues = geoValues.map((item) => item?.value);
    }
    switch (geoType) {
        case 'region':
            return geoValues[0];
        case 'state':
            return geoValues?.join();
        case 'market':
            return geoValues;
        default:
            return [];
    }

}